<template>
    <div 
        id="div_spAnnotations"
        ref="div_spAnnotations"
        style="overflow-y: scroll;"
    >
        <!--         
            @mouseenter="mouseInPanel = true"
            @mouseleave="mouseInPanel = false"
        -->

        <!-- <input 
            id="nodeSearchInput"
            ref="nodeSearchInput"
            type="text" v-model="searchTerm" placeholder="Search..."
        > -->
        <div id="div_nodeSearchStr"
            style="padding-bottom: 10px;"
        >
            <span 
                style="font-family: Verdana, Geneva, Tahoma, sans-serif; font-size: 1.5em; color: blue;"
                title="Digite para pesquisar... / Tecle [ESC] para apagar/terminar" 
            >
                {{ '[ ' + GET_nodeSearchStr + ' ]' }}
            </span>
        </div>

        <Transition name="nodeTransition">
            <ul>
                <nodeCMP v-for="node in GET_rootNodes" :key="node.id"
                    :node="node"
                    :id="node.id"
                ></nodeCMP>
            </ul>
        </Transition>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import _ from 'lodash';
import nodeCMP from './node.vue';
import { gConsts } from '@/globals/gConsts';
import { evtBus  } from '@/main';
import { nodes   } from '@/globals/nodes';
import { mapGetters, mapState, mapActions } from 'vuex';


export default {
    name : 'annotationsCMP',
    components: {
        nodeCMP
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    props: {
        active  : Boolean,
        label   : String,
        panelId : String,
    }, 

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data() {
        return {
//            mouseInPanel : false
        };
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------
    
    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_rootNodes',
            'GET_nodeSearchStr',
            'GET_togglesNodeSearch',
            'GET_filteredNodes'
        ]),
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch: {
        // Quando os filtered nodes mudam, tenho que selecionar o 1o step novamente
        GET_filteredNodes(newFilteredNodes) {
            let firstRootNode = (this.GET_rootNodes.length > 0) 
                ? this.GET_rootNodes[0] 
                : null;

            if ((!this.GET_nodeSearchStr.trim()) || (firstRootNode == null)) {
                return;
            } else {
                nodes.activateNode(firstRootNode, newFilteredNodes);
            }
        },

        // -----------------------------------------------------------------

        // mouseInPanel() {
        //     console.log((this.mouseInPanel ? 'annotations_mouseEnter' : 'annotations_mouseLeave'));
        // },

        // -----------------------------------------------------------------
        
        active(newVal, oldVal) {
            console.log(`[activeChange] activeSp: ${this.active}, mInPanel: ${this.mouseInPanel}, nSStr: ${this.GET_nodeSearchStr}, nSActive: ${this.GET_togglesNodeSearch} `);

            /* Na ativação [this.active]/[newVal == true] olho se o mouse está sobre o painel 
                   e disparo o timer de colapso caso não esteja. */
            if (this.active) {
                if (!this.mouseInPanel) {
                    this.$parent.spsLeave(gConsts.ui.sidePanel.timeouts.SEARCH_COLLAPSE);
                }
            // Na desativação, desligo reseto o nodeSearch se estiver ativo
            } else {
                if (this.GET_togglesNodeSearch) {
                    this.ACT_uiUpdate({ 
                        sidePanels : { nodeSearchStr : ''    },
                        toggles    : { nodeSearch    : false }
                    });
                }            
            }

//            console.log(`[evt_nodeSearchAction|after(deactivation)] spActive: ${this.active}, mInPanel: ${this.mouseInPanel}, nSStr: ${this.GET_nodeSearchStr}, nSActive: ${this.GET_togglesNodeSearch} `);
        }
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
                'ACT_uiUpdate',
        ]),

        mouseInPanel() {
            var spBBox = this.$refs.div_spAnnotations.getBoundingClientRect();
                 
            return ( (spBBox.left   < this.GET_mov_mousePos.x) &&
                     (spBBox.right  > this.GET_mov_mousePos.x) &&
                     (spBBox.top    < this.GET_mov_mousePos.y) &&
                     (spBBox.bottom > this.GET_mov_mousePos.y) );
        },

        // -----------------------------------------------------------------        

        handleNodeSearchAction(action, newSearchStr, wa) {
            var panelState_payload,
                nodeSearchState_payload,
                merged_payload;

                panelState_payload      = this.nodeSearchActions_panelState(action, wa);                 // gerencia o state do painel de acordo com a nodeSearch action.
                nodeSearchState_payload = this.nodeSearchActions_nodeSearchState(action, newSearchStr);  // gerencia o state do nodeSearch de acordo com as nodeSearch action.

                merged_payload = _.merge({}, panelState_payload, nodeSearchState_payload);

                if (Object.keys(merged_payload).length > 0) {
                    this.ACT_uiUpdate(merged_payload);  // Executa a mudanca de estado se houver.
                }
        },

        // -----------------------------------------------------------------        

        /* Deals with the annotations panel state during nodeSearch actions.
               OBS: inserting the appropriate values in the payload it receives as parameter.
               - prevents collapse if active (except on a DISABLE)  
               - expands/activates, and changes sides for INPUT and LOCATION_FILTER
               - deactivates on DISABLE */
        nodeSearchActions_panelState(action, wa) {
            var waBBox, panelSide,
                payload = {}; 

            switch (action) {
                case gConsts.node.search.actions.LOCATION_FILTER :
                case gConsts.node.search.actions.INPUT           : 
                case gConsts.node.search.actions.NAV_NEXT        :
                case gConsts.node.search.actions.NAV_PREV        :
                    if (this.active) {                    
                        if (!this.mouseInPanel) {
                            // Se houve [evt_nodeSearchAction], mesmo com o mouse fora do sPanel, ele deve continuar ativo 
                            this.$parent.spsResetCollapse(gConsts.ui.sidePanel.timeouts.SEARCH_COLLAPSE);
                        }
                    } else {
                        // Especificamente para INPUT e LOCATION_FILTER, se o sPanel não está ativo, devemos ativá-lo
                        switch (action) {
                            case gConsts.node.search.actions.LOCATION_FILTER :
                            case gConsts.node.search.actions.INPUT           :                                 
                                // Muda o lado do painel se ele estiver se ele for ficar sobre o mouse quando expandir
                                waBBox = wa.getBoundingClientRect(),
                                panelSide = ((waBBox.width/2) < this.GET_mov_mousePos.x) ? gConsts.ui.sidePanel.sides.LEFT : gConsts.ui.sidePanel.sides.RIGHT;

                                payload['sidePanels'] = { 
                                    activeSp    : this.panelId,
                                    spAnnotSide : panelSide
                                };
//                                console.log(`mouse pos [x/y] : [${this.GET_mov_mousePos.x} / ${this.GET_mov_mousePos.y}]`);
                                break;
                        }
                    }
                    break;
                
                case gConsts.node.search.actions.DISABLE :
                    /* Aqui eu só desativo o painel e deixo pro [watch.active] resetar o nodeSearch state
                           - [ui.sidePanels.nodeSearchStr = ''] e [ui.toggles.nodeSearch = false].
                       Centralizo no watch pois este reset tb acontece com [sidePanels.spsLeave] */
                    payload['sidePanels'] = { activeSp : '' };
                    break;
            }

            return payload;
        },

        // -----------------------------------------------------------------        

        /* Deals with the nodeSearch state during nodeSearch events/actions.
               OBS: inserting the appropriate values in the payload it receives as parameter.
               - toggles nodeSearch on INPUT and LOCATION_FILTER;
               - updates nodesSearchStr on INPUT;
               - performs node navigagion on NAV_NEXT and NAV_PREV
               - deactivates on DISABLE. */
        nodeSearchActions_nodeSearchState(action, newSearchStr) {
            var payload = {}; 

            switch (action) {
                case gConsts.node.search.actions.LOCATION_FILTER :
                case gConsts.node.search.actions.INPUT           : 
                    if (!this.GET_togglesNodeSearch) {
                        payload['toggles'] = { nodeSearch : true }
                    }

                    if ( (action == gConsts.node.search.actions.INPUT) && 
                         (newSearchStr != this.GET_nodeSearchStr     ) ) {
                        payload.sidePanels = payload.sidePanels ?? {};
                        payload.sidePanels.nodeSearchStr = newSearchStr;
                    }
                    break;
                case gConsts.node.search.actions.NAV_NEXT : nodes.labelNav(gConsts.ui.shortcuts.NEXT); break;
                case gConsts.node.search.actions.NAV_PREV : nodes.labelNav(gConsts.ui.shortcuts.PREV); break;              
            }

            return payload;
        },
    },

    // -----------------------------------------------------------------        

    mounted() {
    },

    // -----------------------------------------------------------------        
    
    created() {
        evtBus.$on('evt_nodeSearchAction', this.handleNodeSearchAction);
    }

    // -----------------------------------------------------------------

};
</script>

// =========================================================================================
// =========================================================================================

<style>

.ulMain {
    list-style: none;
    padding-left:0px;
    margin-top: 0px;
    position: relative;
    height: 100%;
    top: 0px;
    left: 0px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.nodeTransition-enter-active {
    transition: opacity 0.2s ease-in;
}

.nodeTransition-leave-active {
    transition: opacity 0s;
}

.nodeTransition-enter-to, .step-leave {
    opacity: 1;
}

.nodeTransition-enter, .nodeTransition-leave-to {
    opacity: 0;
}

</style>